import UsersAPI from "../API/users.api";
import { getItem } from "./StorageHelpers";

const fetchLoggedUser = async (setter) => {
    try {
        const result = (await UsersAPI.getUserWithoutId()) || {};

        if (setter) setter(result);

        return result;
    } catch (e) {
        console.log(e);
    }
};

// Get any attribute from user object in local storage
const getUserAttributeObj = (attr) => {
    return JSON.parse(getItem("user") ?? null)?.[attr];
};

export { fetchLoggedUser, getUserAttributeObj };
